<template>
    <div class="flex flex-col gap-4 h-full overflow-y-auto pt-20 xl:pt-8 p-4">
        <div class="mb-6">
            <h1 class="text-2xl sm:text-3xl font-bold text-foreground text-eblack-900">{{ $t("customer.auto.clientes") }}</h1>
        </div>

        <div class="grid gap-4 sm:gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mb-6">
            <div class="border rounded-2xl border-ewhite-200 bg-gradient-to-br from-white to-ewhite-50">
                <div class="p-8">
                    <div class="flex items-center justify-between">
                        <div class="space-y-1">
                            <p class="text-sm font-medium text-muted-foreground">{{ $t("customer.auto.total_clientes") }}</p>
                            <p class="text-2xl font-bold text-foreground">{{ overview.totalCustomers }}</p>
                        </div>
                        <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100">
                            <IconUsers class="h-6 w-6 text-blue-600" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="border rounded-2xl border-ewhite-200 bg-gradient-to-br from-white to-ewhite-50">
                <div class="p-8">
                    <div class="flex items-center justify-between">
                        <div class="space-y-1">
                            <p class="text-sm font-medium text-muted-foreground">{{ $t("customer.auto.nuevos_este_mes") }}</p>
                            <p class="text-2xl font-bold text-foreground">{{ overview.newCustomersThisMonth }}</p>
                        </div>
                        <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-egreen-100">
                            <IconUserCheck class="h-6 w-6 text-egreen-600" />
                        </div>
                    </div>
                </div>
            </div>

            <div></div>
        </div>

        <div class="flex flex-col sm:flex-row gap-6 mb-6">
            <button type="button"
            class="bg-egreen-400 w-auto text-white px-4 py-3 md:py-2 rounded-lg text-md inline-flex justify-center items-center gap-2"
            @click="showModal()">
                <span >
                    <svg  
                    xmlns="http://www.w3.org/2000/svg"   
                    width="24" 
                    height="24"  
                    viewBox="0 0 24 24"  
                    fill="none"  
                    stroke="currentColor"  
                    stroke-width="2"  
                    stroke-linecap="round"  
                    stroke-linejoin="round" 
                    class="w-5 h-5 "><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
                </span>
                <span>{{ $t("customer.auto.agregar") }}</span>
            </button>

            <div class="relative flex-1 flex justify-end">
                <div class="relative w-full md:w-80 ">  
                    <IconSearch class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <input 
                    type="text" 
                    name="search"
                    v-model="search" 
                    class="rounded-lg border-ewhite-300 text-md w-full md:w-80 focus:ring-blue-500 px-4 py-2 pl-9"
                    :placeholder="$t('customer.auto.clientes_osud4')">
                </div>
            </div>
        </div>

        <CustomerCard v-if="customers.length > 0" ref="customerCard" :customers="customers" :showModal="showModal" :search="search" />

        <div v-else class="flex flex-col items-center justify-center py-16 bg-ewhite-100 rounded-xl">
            <div class="flex h-20 w-20 items-center justify-center rounded-full bg-eblack-100 mb-4">
                <IconUsers class="h-10 w-10 text-eblack-400" />
            </div>
            <p class="text-sm text-muted-foreground">{{ $t("customer.auto.no_se_encontraron_clientes") }}</p>
        </div>
    </div>
</template>

<script>
import customerRequests from '@/services/admin/customer-service';
import CustomerCard from './components/CustomerCard.vue';
import CustomerFormSidebar from './components/CustomerFormSidebar.vue';
import { useOverlay } from '@/services/overlay-service';
import { createSidebarConfig } from '@/utils/overlay-utils';
import { IconSearch, IconUserCheck, IconUsers } from '@tabler/icons-vue';

export default {
    name:"CustomerIndex",
    data(){
        return {
            customer:null,
            customers:[],
            errors:[],
            search:'',
            viewClicked:false,
            currentOverlayId: null,
            overview:{
                totalCustomers:0,
                newCustomersThisMonth:0
            }
        }
    },
    setup() {
        const overlayService = useOverlay();
        return { overlayService };
    },
    components:{
        CustomerCard,
        IconSearch,
        IconUserCheck,
        IconUsers
    },
    methods:{
        showModal(customer=null,viewClicked=false){
            this.customer = customer;
            this.viewClicked = viewClicked;
            
            this.currentOverlayId = this.overlayService.open(
                createSidebarConfig({
                    component: CustomerFormSidebar,
                    props: {
                        customer: this.customer,
                        loadData: this.initData,
                        viewClicked: this.viewClicked,
                        overlayService: this.overlayService
                    },
                    onClose: () => {
                        this.customer = null;
                        this.viewClicked = false;
                        this.currentOverlayId = null;
                    }
                })
            );
        },
        initData(){
            customerRequests.getAll()
            .then(
                res => {
                    if(res.status == 200){
                        let {data} = res
                        this.customers = data
                        this.prepareOverview(data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error)
                }
            )
        },
        prepareOverview(data){
            console.log(data)
            this.overview.totalCustomers = data.length;
            const currentMonth = new Date().getMonth();
            const newCustomers = data.filter(customer => {
                const createdAt = new Date(customer.created_at);
                return createdAt.getMonth() === currentMonth;
            });
            this.overview.newCustomersThisMonth = newCustomers.length;
        }
    },
    mounted(){
        this.initData()
    }
}
</script>

<style lang="scss" scoped>

</style>